import React from 'react';

import { Tabs, Tooltip } from 'antd';

import styled from 'styled-components';

import { useBookingEvent } from '@components/EventDrawer/BookingEvent/BookingEventContext';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const TabsStyled = styled(Tabs)`
    /* .ant-tabs-content-holder {
        @media only screen and (max-width: 720px) {
            padding-top: 3.25rem;
        }
    } */

    .ant-tabs-content {
        padding-top: 0;
        margin-bottom: ${(props) => props.$mobileView && '60px'};
    }
    .ant-tabs-nav-list {
        padding-right: ${(props) => (props.$mobileView ? '0' : '2rem')};
        justify-content: ${(props) => (props.$mobileView ? 'center' : 'flex-end')};
        width: 100%;
        .ant-tabs-tab {
            min-width: 40px;
            display: flex;
            justify-content: center;
            .ant-tabs-tab-btn svg {
                font-size: 1.5em;
            }
        }
    }
    &.ant-tabs {
        position: relative;
        overflow: visible;
        .ant-tabs-nav {
            position: sticky;
            right: 8px;
            z-index: 5;
            top: 80px;
            width: 100%;
            margin: 0;
            margin-top: -50px;

            @media only screen and (max-width: 720px) {
                top: 0;
                margin-top: unset;
                margin-bottom: 1rem;
            }

            .ant-tabs-nav-wrap {
                /* position: ${(props) => props.$mobileView && 'fixed'};
                bottom: ${(props) => props.$mobileView && 0}; */
                background: ${(props) => props.$mobileView && 'white'};
                width: 100%;
                padding-right: ${(props) => props.$mobileView && '8px'};
                border-bottom: ${(props) => props.$mobileView && props.theme.DefaultBorder};
            }
        }
    }
`;

const EventDrawerTabs = ({ tabs, activeKey, onSetLayout }) => {
    const onDrawerTabChange = (key) => {
        document.querySelector('.ant-drawer-body').scrollTop = 0;
        if (onSetLayout) {
            onSetLayout(key);
        }
    };
    const { isMobile, breakpoint } = useBookingEvent();

    return (
        tabs && (
            <TabsStyled
                $mobileView={isMobile}
                activeKey={activeKey}
                defaultActiveKey="calendar"
                size="middle"
                destroyInactiveTabPane
                onChange={onDrawerTabChange}
                items={[
                    {
                        label: (
                            <Tooltip title="Project Timeline">
                                <NwIcon icon={byPrefixAndName.fasl['calendar-alt']} />
                            </Tooltip>
                        ),
                        key: 'calendar',
                        children: tabs[0],
                    },
                    {
                        label: (
                            <Tooltip title="Fees and Expenses">
                                <NwIcon icon={byPrefixAndName.fasl['message-dollar']} />
                            </Tooltip>
                        ),
                        key: 'invoice',
                        children: tabs[1],
                    },
                    {
                        label: (
                            <Tooltip title="Callsheet">
                                <NwIcon icon={byPrefixAndName.fasl['address-book']} />
                            </Tooltip>
                        ),
                        key: 'address',
                        children: tabs[2],
                    },
                    {
                        label: (
                            <Tooltip title="Documents">
                                <NwIcon icon={byPrefixAndName.fasl['paperclip']} />
                            </Tooltip>
                        ),
                        key: 'attachments',
                        children: tabs[3],
                    },
                ]}
            ></TabsStyled>
        )
    );
};

export default EventDrawerTabs;
